import styled from 'styled-components'
import tw from 'twin.macro'

export const ToolGetHelpWrapper = styled.div`
  ${tw`grid grid-cols-12`}
`
export const ToolGetHelpHeadingWrapper = styled.div`
  ${tw`xs:col-span-12 md:col-span-6`}
`
export const ToolGetHelpTextWrapper = styled.div`
  ${tw`flex`}
`
export const ToolGetHelpText = styled.p`
  ${tw`text-xl	font-medium py-5`}
`
export const ToolFlyoutHeaderSidebarWrapper = styled.div`
  ${tw`xs:flex xs:justify-between lg:block xs:pt-3 lg:pt-0`}
`
export const ToolFlyoutHeaderSidebarTextWrapper = styled.p`
  ${tw`text-xs font-bold uppercase text-silver-lighter1x`}
`
export const ToolFlyoutHeaderSidebarCategoryWrapper = styled.p`
  ${tw`text-black-light text-xl font-light pt-1`}
`
